import TagManager from '../../../classes/TagManager';
import ProductListSlider from '../../organisms/productListSlider/ProductListSlider';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { isPlainObject } from '../../../utils/assertions';
import { optionsRecentlyViewed, titleOptions } from './utils/options';
import { useNostoContext } from '../../../provider/nosto/NostoContext';
import { parseProducts } from '../../../provider/nosto/utils';

const RecentlyViewedProduct = ({
  recentlyViewedTitle,
  recentlyViewedPlacement,
  nostoProductClick,
}) => {
  const { placementData } = useNostoContext();
  const blockRef = useRef(null);
  const { wishlist } = useSelector((state) => state.wishlist);

  const nostoTitle = placementData[recentlyViewedPlacement]?.title;
  const title = nostoTitle ?? (recentlyViewedTitle || titleOptions['recently'].title);

  const { mdSlidesPerView, lgSlidesPerView, xlSlidesPerView } =
    optionsRecentlyViewed;

  useEffect(() => {
    if (
      isPlainObject(placementData) &&
      isPlainObject(placementData[recentlyViewedPlacement])
    ) {
      TagManager.productImpressionsDynamic(
        placementData[recentlyViewedPlacement]?.products,
        title,
      );
    }
  }, [placementData]);

  return isPlainObject(placementData) &&
    isPlainObject(placementData[recentlyViewedPlacement]) &&
    placementData[recentlyViewedPlacement]?.products?.length > 2 ? (
    <>
      <span ref={blockRef} />
      <ProductListSlider
        placement="product"
        smSlidesPerView="auto"
        mdSlidesPerView={mdSlidesPerView}
        lgSlidesPerView={lgSlidesPerView}
        xlSlidesPerView={xlSlidesPerView}
        smOffsets={20}
        mdOffsets={20}
        lgOffsets={40}
        xlOffsets={143}
        products={parseProducts(placementData[recentlyViewedPlacement]?.products)}
        title={title}
        titleAlign="center"
        wishlist={wishlist}
        centerInsufficientSlides
        type="recently-viewed"
        scrollBarVisibility="mobile"
        listName={title}
        nostoPlacement={recentlyViewedPlacement}
        nostoCallback={nostoProductClick}
      />
    </>
  ) : null;
};

export default RecentlyViewedProduct;
